import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { faMinus } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { Stack } from '../../Atoms/Stack';
import Badge from '../Badge/Badge';
export const BadgeList = ({ items, stackWrapperProps, maxItems = 0 }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    if (items.length === 0)
        return null;
    return (_jsxs(Stack, { wrap: true, gap: "s", alignment: "center", ...stackWrapperProps, children: [items
                .slice(0, !maxItems || isExpanded ? items.length : maxItems)
                .map((item) => (_createElement(Badge, { ...item, key: item.key }))), !!maxItems && items.length > maxItems && (_jsx(_Fragment, { children: _jsx(Badge, { label: isExpanded ? '' : `${items.length - maxItems}+`, icon: isExpanded ? faMinus : undefined, variant: "ghost", schema: "neutral", size: "xs", bold: true, onClick: () => setIsExpanded((prev) => !prev) }) }))] }));
};
//# sourceMappingURL=BadgeList.js.map